import { z } from 'zod';

export const localeSchema = z.enum(['hr', 'en']);
export const idSchema = z.string().uuid();
export const daySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Očekuje se YYYY-MM-DD');

export const paginationSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(25),
});

export function paginated<T extends z.ZodTypeAny>(item: T) {
  return z.object({ items: z.array(item), nextCursor: z.string().nullable() });
}

export const okSchema = z.object({ ok: z.literal(true) });
